import regeneratorRuntime from "regenerator-runtime";
import "isomorphic-fetch";

export default class Ajaxjs {
    constructor() {

    }

    async getJsonAsync(action) {
        const resp = await fetch(url);
        return resp.json();
    }

    async serializeAndPostForm(formId, action, controller) {
        return await this.postForm(action, controller, this.serializeForm(formId));
    }

    async postForm(action, controller, formData) {
        var url = `${window.location.protocol}//${window.location.host}/${controller}/${action}`;
        var response = await fetch(url, {
            method: 'POST',
            credentials: 'same-origin',       
            body: formData,
        });
        var resultText = await response.text();
        if (resultText.charAt(0) === '<') return 500;
        return resultText;
    }

    serializeFormWithCustom(formId, custom) {
        var formData = new FormData();
        var inputs = document.forms[formId].getElementsByTagName("input");
        var selects = document.forms[formId].getElementsByTagName("select");
        var textareas = document.forms[formId].getElementsByTagName("textarea");
        var i = 0;

        var keys = Object.keys(custom);
        for (var i = 0; i < keys.length; i++)
            formData.append(keys[i], custom[keys[i]]);

        for (i = 0; i < inputs.length; i++) {
            //var input = inputs[i];
            if (inputs[i].type === "file") {
                formData.append('file', inputs[i].files[0]);
            }
            else if (inputs[i].type === "radio" || inputs[i].type === "checkbox") {
                if (inputs[i].checked === true) {
                    formData.append(inputs[i].name, inputs[i].value);
                }
            }
            else {
                formData.append(inputs[i].name, inputs[i].value);
            }
        }
        for (i = 0; i < textareas.length; i++) {
            formData.append(textareas[i].name, textareas[i].value);
        }
        for (i = 0; i < selects.length; i++) {
            formData.append(selects[i].name, selects[i].value);
        }
        return formData;
    }

    serializeForm(formId) {
        var formData = new FormData();
        var inputs = document.forms[formId].getElementsByTagName("input");
        var selects = document.forms[formId].getElementsByTagName("select");
        var textareas = document.forms[formId].getElementsByTagName("textarea");
        var i = 0;
        for (i = 0; i < inputs.length; i++) {
            //var input = inputs[i];
            if (inputs[i].type === "file") {
                formData.append('file', inputs[i].files[0]);
            }
            else if (inputs[i].type === "radio" || inputs[i].type === "checkbox") {
                if (inputs[i].checked === true) {
                    formData.append(inputs[i].name, inputs[i].value);
                }
            }
            else {
                formData.append(inputs[i].name, inputs[i].value);
            }
        }
        for (i = 0; i < textareas.length; i++) {
            formData.append(textareas[i].name, textareas[i].value);
        }
        for (i = 0; i < selects.length; i++) {
            formData.append(selects[i].name, selects[i].value);
        }
        return formData;
    }

    serializeMultipleFileForm(formId) {//=> expenseForm
        var formData = new FormData();
        var inputs = document.forms[formId].getElementsByTagName("input");
        var selects = document.forms[formId].getElementsByTagName("select");
        var i = 0;
        for (i = 0; i < inputs.length; i++) {
            if (inputs[i].type === "file") {
                const files = inputs[i].files;
                for (var f = 0; f < files.length; f++) {
                    formData.append(files[f].name, files[f]);
                }
            } else {
                formData.append(inputs[i].name, inputs[i].value);
            }
        }
        for (i = 0; i < selects.length; i++) {
            formData.append(selects[i].name, selects[i].value);
        }
        return formData;
    }

    loadPartialActionControllerQuerystringElement(action, controller, queryStringFullyFormed, element, callback) {
        const url = `${window.location.protocol}//${window.location.host}/${controller}/${action}${queryStringFullyFormed}`;
        const req = new XMLHttpRequest();
        req.open("GET", url);
        req.onload = () => {
            element.innerHTML = req.responseText;
            if (callback) {
                callback();
            }
        };
        req.onerror = () => req.statusText;
        req.send(null);
    }

    loadPartialActionControllerQuerystringElementId(action, controller, queryStringFullyFormed, elementId) {
        const element = document.getElementById(elementId);
        const url = `${window.location.protocol}//${window.location.host}/${controller}/${action}${queryStringFullyFormed}`;
        const req = new XMLHttpRequest();
        req.open("GET", url);
        req.onload = () => {
            element.innerHTML = req.responseText;
            this.executeScript(req.responseText);
        };
        req.onerror = () => req.statusText;
        req.send(null);

        
    }

    fetchActionControllerQuerystring(action, controller, queryStringFullyFormed) {
        const url = `${window.location.protocol}//${window.location.host}/${controller}/${action}${queryStringFullyFormed}`;
        const req = new XMLHttpRequest();
        req.open("GET", url);
        req.onload = () => {
            
        };
        req.onerror = () => req.statusText;
        req.send(null);
    }

    async serializeAndPostFormValidation(formId, action, controller) {
        var data = this.serializeFormWithValidation(formId);
        if (data) {
            return await this.postForm(action, controller, data);
        }
    }

    serializeFormWithValidation(formId) {
        var data = {};
        var requiredData = {};
        var inputs = document.forms[formId].getElementsByTagName("input");
        var selects = document.forms[formId].getElementsByTagName("select");
        var i = 0;
        for (i = 0; i < inputs.length; i++) {
            data[inputs[i].name] = inputs[i].value;
            if (inputs[i].hasAttribute('required')) {
                requiredData[inputs[i].name] = inputs[i].value;
            }
        }

        for (i = 0; i < selects.length; i++) {
            data[selects[i].name] = selects[i].value;
            if (selects[i].hasAttribute('required')) {
                requiredData[selects[i].name] = selects[i].value;
            }
        }
        if (this.validateInputWithLabels(requiredData)) {
            return data;
        }
        return false;
    }

    validateInputWithLabels(data) {
        let validated = true;
        for (var key in data) {
            if (!data[key]) {
                validated = false;
                this.showById(`${key}Validate`);
            } else {
                this.hideById(`${key}Validate`);
            }
        }
        return validated;
    }

    postBackToSameURLQuerystringElement(queryStringFullyFormed, element) {
        return new Promise((resolve, reject) => {
            const url = `${window.location.protocol}//${window.location.host}/${window.location.pathname}/${queryStringFullyFormed}`;
            const req = new XMLHttpRequest();
            req.open("GET", url);
            req.onload = () => {
                element.innerHTML = req.responseText;
                resolve(200);
            };
            req.onerror = () => reject(req.statusText);
            req.send(null);
        });
    }


    executeScript(html) {

        var regDetectJs = /<script(.|\n)*?>(.|\n|\r\n)*?<\/script>/ig;
        var jsContained = html.match(regDetectJs);

        if (jsContained) {
            var regGetJS = /<script(.|\n)*?>((.|\n|\r\n)*)?<\/script>/im;

            var jsNums = jsContained.length;
            for (var i = 0; i < jsNums; i++) {
                var jsSection = jsContained[i].match(regGetJS);

                if (jsSection[2]) {
                    if (window.execScript) {
                        window.execScript(jsSection[2]);
                    } else {
                        window.eval(jsSection[2]);
                    }
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./Scripts/es6/ajax.js